export const sundayAbbreviatedLowercase = "yra";
export default {sundayAbbreviatedLowercase};